import toast from "react-hot-toast";

import ToastAlert from "../../components/ui/ToastAlert";

export function notify(type, text, right) {
  toast.remove();
  const toastId = toast.custom(<ToastAlert message={text} type={type} onClose={() => toast.remove(toastId)} />, {
    position: right ? "top-center" : "bottom-left",
    style: {
      width: "fit-content",
      maxWidth: "calc(100vw - 32px)",
    },
  });
}
